import React from "react";
import styles from "./gateway-details-dropdown.module.scss";
import { GatewayDetails } from "@src/types/gateway-onboarding";
import { useI18N } from "@src/language/language-context";
import { AttributeNameValue } from "@src/components/atoms/attribute-name-value/attribute-name-value";

const cssClassName = "gateway-details-dropdown";

interface GatewayDetailsDropdownProps {
  gatewayDetails: GatewayDetails;
}

export const GatewayDetailsDropdown = ({
  gatewayDetails,
}: GatewayDetailsDropdownProps) => {
  const i18n = useI18N();

  const texts = {
    gatewayUuid: i18n("modules.addNewGatewayDrawerModal.gatewayUuid"),
    gatewayName: i18n("modules.addNewGatewayDrawerModal.gatewayName"),
    vendorId: i18n("modules.addNewGatewayDrawerModal.vendorId"),
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__details`]}>
        <div className={styles[`${cssClassName}__details-content`]}>
          <AttributeNameValue
            name={texts.gatewayName}
            value={gatewayDetails.name || "—"}
          />
          {gatewayDetails.vendor_id != null && (
            <AttributeNameValue
              name={texts.vendorId}
              value={gatewayDetails.vendor_id}
            />
          )}
          <AttributeNameValue
            name={texts.gatewayUuid}
            value={gatewayDetails.gateway_id || "—"}
          />
        </div>
      </div>
    </div>
  );
};
